import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { api, apiError } from "../../lib/api";
import { useLang } from "../../lib/i18n";

const REASONS = ["spam", "inapropiado", "menor", "acoso", "perfil_falso", "otro"];

export function ReportUserDialog({ open, onOpenChange, conversationId }) {
  const { t } = useLang();
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/conversations/${conversationId}/report`, { reason, details });
      toast.success(t("rep.done"));
      onOpenChange(false);
      setReason("");
      setDetails("");
    } catch (e) {
      toast.error(apiError(e, t));
    }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-3xl border-0 p-6" data-testid="report-user-dialog">
        <DialogTitle className="text-xl font-extrabold text-navy">{t("rep.title")}</DialogTitle>
        <DialogDescription className="text-sm text-slate-500">{t("rep.sub")}</DialogDescription>
        <div className="flex flex-wrap gap-2">
          {REASONS.map((r) => (
            <button key={r} onClick={() => setReason(r)} data-testid={`report-reason-${r}`}
              className={`rounded-full border-[1.5px] px-3.5 py-1.5 text-sm font-semibold transition-colors ${reason === r ? "border-alert bg-alert text-white" : "border-slate-200 text-navy hover:border-alert/50"}`}>
              {t(`rep.reason.${r}`)}
            </button>
          ))}
        </div>
        <textarea className="field min-h-[90px]" maxLength={1000} value={details} placeholder={t("rep.detailsPh")}
          onChange={(e) => setDetails(e.target.value)} data-testid="report-user-details-input" />
        <div className="flex gap-2.5">
          <button className="btn-outline flex-1" onClick={() => onOpenChange(false)} data-testid="report-user-cancel-btn">{t("mine.cancel")}</button>
          <button className="flex-1 rounded-full bg-alert py-3 font-bold text-white transition-opacity hover:opacity-90 disabled:opacity-50"
            disabled={busy || !reason} onClick={send} data-testid="report-user-send-btn">{t("rep.send")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function ConfirmDialog({ open, onOpenChange, title, sub, confirmLabel, onConfirm, testid }) {
  const { t } = useLang();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-sm rounded-3xl border-0 p-6" data-testid={testid}>
        <DialogTitle className="text-xl font-extrabold text-navy">{title}</DialogTitle>
        <DialogDescription className="text-sm text-slate-500">{sub}</DialogDescription>
        <div className="flex gap-2.5">
          <button className="btn-outline flex-1" onClick={() => onOpenChange(false)} data-testid={`${testid}-cancel`}>{t("mine.cancel")}</button>
          <button className="flex-1 rounded-full bg-alert py-3 font-bold text-white transition-opacity hover:opacity-90"
            onClick={() => { onOpenChange(false); onConfirm(); }} data-testid={`${testid}-confirm`}>{confirmLabel}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
